import { render } from "./ShowDossier.vue?vue&type=template&id=7090c532&scoped=true"
import script from "./ShowDossier.vue?vue&type=script&lang=js"
export * from "./ShowDossier.vue?vue&type=script&lang=js"

import "./ShowDossier.vue?vue&type=style&index=0&id=7090c532&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7090c532"]])

export default __exports__